import type { FC } from "react";

import type {
  ClientFilterCounts,
  ClientListFilter
} from "@/api/types/clientDirectory";
import { FilterChip } from "@/components/ui/filter-chip";

const FILTERS: Array<{
  value: ClientListFilter;
  label: string;
  count?: keyof ClientFilterCounts;
}> = [
  { value: "status_ended", label: "Status Ended", count: "status_ended" },
  { value: "expiring", label: "Expiring in 90 Days", count: "expiring" },
  { value: "duplicates", label: "Possible Duplicates", count: "duplicates" },
  { value: "not_invited", label: "Not Invited to Portal" },
  { value: "archived", label: "Archived", count: "archived" }
];

type Props = {
  value: ClientListFilter | "";
  counts: ClientFilterCounts | null;
  onChange: (value: ClientListFilter | "") => void;
};

/** One-tap list filters; tapping the active one clears it. */
export const ClientsQuickFilters: FC<Props> = ({ value, counts, onChange }) => (
  <div
    role="group"
    aria-label="Filter Clients"
    className="flex min-w-0 scrollbar-none items-center gap-1.5 overflow-x-auto [&::-webkit-scrollbar]:hidden"
  >
    {FILTERS.map((f) => {
      const n = f.count ? counts?.[f.count] : undefined;
      return (
        <FilterChip
          key={f.value}
          active={value === f.value}
          count={typeof n === "number" && n > 0 ? n : undefined}
          onClick={() => onChange(value === f.value ? "" : f.value)}
          data-testid={`clients-filter-${f.value}`}
        >
          {f.label}
        </FilterChip>
      );
    })}
  </div>
);
